import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess, toastWarning } from '@apps-common/lib/toast'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

const findMyMonitoringUserByEmail = async (email: string): Promise<IMyMonitoringUserModel> =>
  axios.get(`/my-monitoring/sites/FindMyMonitoringUserByEmail?email=${email}`).then((res) => res.data?.data)

type Props = {
  email: string
}

export const useMyMonitoringFindMyMonitoringUserByEmail = (notify?: boolean, onSuccess?: (data: IMyMonitoringUserModel) => void) =>
  useMutation({
    mutationKey: ['findMyMonitoringUserByEmail'],
    mutationFn: ({ email }: Props) => findMyMonitoringUserByEmail(email),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (data) {
        toastSuccess('Account found. Proceeding with updating existing account.')
      } else {
        toastWarning('No account found. Proceeding with create new account.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Error searching, please try again.')
      }
    },
    throwOnError: false
  })
